export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10019.c3ceb51c.jpg";